<div class="wrapper-mini text-center auth-form">
    <h1 class="header">Login</h1>

    <div class="form-block text-left">
        <label for="email">Email</label>
        <input id="email" type="text" name="email" data-testid="input-login-email" [(ngModel)]="email" (keyup.enter)="login()">
    </div>

    <div class="form-block text-left">
        <label for="password">Password</label>
        <input id="password" type="password" name="password" data-testid="input-login-password" [(ngModel)]="password" (keyup.enter)="login()">
        <a class="text-color-primary text-small" data-testid="link-forgot-password" [routerLink]="['/auth/forgot']">Forgot password?</a>
    </div>


    <div class="footer">
        <saffron-button text="Login"
                        data-testid="btn-login"
                        size="wide" 
                        type="primary" 
                        [is_disabled]="!email || !password"
                        [is_loading]="loading"
                        (click)="login()">
        </saffron-button>
        <p>
            Don't have an account?
            <a class="text-color-primary" data-testid="link-signup" [routerLink]="['/auth/signup']">Sign up</a>
        </p>
    </div>
    
</div>